<script setup lang="ts">
import TabMenu from "@/components/TabMenu.vue";
import {IBaseMenuItem} from "@/models";

const props = defineProps({
  menuItems: {type: Array as () => IBaseMenuItem[], default: []},
});
</script>

<template>
  <div id="ct" class="flex-layout-body">
    <nav class="nav nav-files">
      <tab-menu :items="menuItems" :li="false" />
    </nav>
    <!-- [D] 선택 된 순서 data-file="숫자" -->
    <div class="file-content" data-file="3">
      <strong class="file-title">Payment Methods</strong>
      <div class="file-content-hd">
        <h2 class="fs-1">Payment Methods</h2>
        <p class="info-txt">설정된 수금 방법은 다음 번 주문 때부터 적용됩니다.</p>
        <button type="submit" class="btn btn-outline d-inline-flex">결제 방법 저장</button>
      </div>
      <div class="btn-check-wrap payment-check">
        <label class="btn-check">
          <input type="radio" name="expose" class="sr-only" checked>
          <span class="btn btn-outline-primary">
                    <img src="@/assets/playground/img/payment-point.png" alt="">
                    <strong class="fs-3 text-dark">포인트 결제</strong>
                    <span class="box">주문자가 보유하고 있는 포인트를 사용하여 <br>
                    작업 대금을 결제하고, 주문이 완료된 이후<br>
                    포인트를 정산받는 방법입니다.</span>
                </span>
        </label>
        <label class="btn-check">
          <input type="radio" name="expose" class="sr-only">
          <span class="btn btn-outline-primary">
                    <img src="@/assets/playground/img/payment-card.png" alt="">
                    <strong class="fs-3 text-dark">직접 정산 받기</strong>
                    <span class="box">주문자와 합의하여 직접 작업 대금을 정산받는 방법입니다.</span>
                </span>
        </label>
      </div>
    </div>

  </div>
</template>

<style scoped>

</style>